import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect } from "react";

export default function Home() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = ""; }, []);

	return <Section center>
		<p>Navigate with caution. This site is still under construction.</p>
	</Section>;
}